import { Action } from '../actions';
import { UPDATE_GOALS_DATA } from '../actions/goals';
import { GoalsDataState } from '../typings/state';

export function goalsEdit(
    state: GoalsDataState = {},
    action: Action
): GoalsDataState {
    switch (action.type) {
        case UPDATE_GOALS_DATA:
            if (Object.keys(action.goals).length === 0) {
                return state;
            }

            return {
                ...state,
                goals: action.goals
            };
        default:
            return state;
    }
}
